import { render, staticRenderFns } from "./RelatedDocumentsControl.vue?vue&type=template&id=536825e7&"
import script from "./RelatedDocumentsControl.vue?vue&type=script&lang=js&"
export * from "./RelatedDocumentsControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports